import type { QueryClient } from "@tanstack/react-query";
import { getFeatureFlag } from "providers/LaunchDarkly/client";

export type TakeoverFlags = { chatEnabled: boolean; onboardingEnabled: boolean };

/** The takeover's flags once LaunchDarkly has identified this manager; a render can still hold the anonymous defaults. */
export const readTakeoverFlags = async (queryClient: QueryClient): Promise<TakeoverFlags> => {
  const [chatEnabled, onboardingEnabled] = await Promise.all([
    getFeatureFlag("agent-web-header-button-admin", { queryClient }),
    getFeatureFlag("agent-web-onboarding", { queryClient }),
  ]);
  return { chatEnabled, onboardingEnabled };
};
